import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, catchError, switchMap, take, map } from 'rxjs';
import { UserSettingsService } from '@user-settings/services/user-settings.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';

/**
 *Used to intercept top level routing and effectively "redirect" to specific product's root route. (Dashboard/MCI do not have a specific root so they are '')
 */
@Injectable()
export class ProductRouteNavigator  {

  constructor(
    private readonly router: Router,
    private readonly userSettings: UserSettingsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userSettings.getUserSettings()
      .pipe(
        map((userSettings) => {
          const product = userSettings.Product;

          if (product === MojoWellKnownNames.Products.MojoForSuppliers) {
            this.router.navigate(['/mfs']);
            return false;
            }

          if (product === MojoWellKnownNames.Products.MojoForTenants) {
            this.router.navigate(['/mft']);
            return false;
          }


          return true;
        }));
  }

}
